import { wrapperClass } from "./discount-actions-table-header.styles";
import { DiscountActionsTableHeaderProps } from "./discount-actions-table-header.types";
import { useDiscountActionSearchContext } from "../../discount-actions.context";
import { CreatePercentageDiscountActionButton } from "../create-percentage-discount-action-button";
import { DiscountActionFilter } from "../discount-action-filter";

export const DiscountActionsTableHeader = ({ connectionId }: DiscountActionsTableHeaderProps) => {
	const { isArchivePage } = useDiscountActionSearchContext();

	return (
		<div className={wrapperClass}>
			<DiscountActionFilter />
			{!isArchivePage && <CreatePercentageDiscountActionButton connectionId={connectionId} />}
		</div>
	);
};
